//App
import useForm from "../../../hooks/useForm";
import { DonorCampaignContextData, DonorProps } from "../../../../types/donorCampaign";
import { DonorCampaignContext } from "../DonorsContainer";

const useDopnorCampaign = (props: DonorProps) => {
  return useForm<DonorCampaignContextData, DonorProps>(DonorCampaignContext, props);
};

export default useDopnorCampaign;
